/**
 * Contesto dell'utente autenticato: chi e, su quali squadre-stagione lavora,
 * come si esce. Lo leggono menu, selettore e scelta del contesto senza
 * passarselo di componente in componente.
 */

import { createContext, useContext } from 'react';
import type { Utente } from '../accesso/useSessione.js';

export interface SquadraStagione {
  id: string;
  squadra: string;
  categoria: string | null;
  stagione: string;
  stagioneCorrente: boolean;
  /** Limiti della stagione, come "2026-07-01": servono al calendario degli allenamenti. */
  dataInizio: string;
  dataFine: string;
  tesserati: number;
}

export interface ContestoUtente {
  utente: Utente;
  /** Null finche l'elenco non arriva: la pagina della partita non lo aspetta. */
  squadre: SquadraStagione[] | null;
  erroreSquadre: string | null;
  /** Dopo una modifica da amministrazione: selettore e ingresso devono vederla. */
  ricaricaSquadre: () => Promise<void>;
  esci: () => Promise<void>;
}

export const Contesto = createContext<ContestoUtente | null>(null);

export function useContesto(): ContestoUtente {
  const valore = useContext(Contesto);
  if (!valore) throw new Error('useContesto va usato dentro ProviderContesto.');
  return valore;
}
